import { render, staticRenderFns } from "./textbookView.vue?vue&type=template&id=0e2f234a&scoped=true"
import script from "./textbookView.vue?vue&type=script&lang=js"
export * from "./textbookView.vue?vue&type=script&lang=js"
import style0 from "./textbookView.vue?vue&type=style&index=0&id=0e2f234a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2f234a",
  null
  
)

export default component.exports